import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetBannerCommand } from '@/app/banner/commands/get-banner.command'

const httpClient = new AxiosClient()

export const getBannerCommand = new GetBannerCommand(httpClient, store)
